import { useSelector } from "react-redux";
import MovieList from "./MovieList";
import Shimmer from "./Shimmer";

const GPTafterresult = () => {
  const gpt = useSelector((store) => store.gpt);
  const { movieResults, movieNames } = gpt;

  return (
   
    <div className="relative mt-60 z-20">
      {movieNames && movieNames.map((video, index) => (
        <MovieList key={index} title={video} nowplaying={movieResults[index]} />
      ))}
    </div>
  )
};
export default GPTafterresult;
